import React from 'react';
import { LayersControl, LayerGroup, GeoJSON } from 'react-leaflet';

/**
 * Camada de limites estaduais
 * @param {Object} props.data GeoJSON de estados
 * @param {boolean} props.checked Estado inicial (padrão true)
 * @param {Object} props.style Estilo opcional para o GeoJSON
 */
export default function StateBoundariesLayer({
  data,
  checked = true,
  style = { fillOpacity: 0, color: 'yellow', weight: 1 },
}) {
  if (!data) return null;
  return (
    <LayersControl.Overlay name="Estados" checked={checked}>
      <LayerGroup>
        <GeoJSON data={data} style={style} />
      </LayerGroup>
    </LayersControl.Overlay>
  );
}
